module.exports = "## Showcase\n\nThe following is a list of some of the public apps using Material-UI. Not all of them have their interface implemented using 100% Material-UI.\n\nWant to add your app? Found an app that no longer works or no longer uses Material-UI? Please submit a pull request on [GitHub](https://github.com/callemall/material-ui) to update this page!\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/discover-more/showcase.md
 ** module id = 1104
 ** module chunks = 0
 **/